import { io, Socket } from 'socket.io-client';

const API_BASE = import.meta.env.VITE_API_URL || '';

let socket: Socket | null = null;

export function connectPortalSocket(token: string): Socket {
  if (socket?.connected) return socket;

  socket = io(API_BASE || undefined, {
    path: '/ws',
    auth: { portalToken: token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
  });

  socket.on('connect', () => {
    console.log('[Portal] WebSocket connected');
  });

  socket.on('disconnect', (reason: string) => {
    console.log('[Portal] WebSocket disconnected:', reason);
  });

  return socket;
}

export function getPortalSocket(): Socket | null {
  return socket;
}

export function disconnectPortalSocket() {
  socket?.disconnect();
  socket = null;
}
